define('models/password_reset',['require','backbone'],function(require){

    var Backbone = require('backbone');

    return Backbone.Model.extend({
        url : function() {
            // set the endpoint for restful api for articles
            return this.id ? ( App.Config.apiBase + 'auth/password-reset/' + this.code + '/' ) :
                ( App.Config.apiBase + 'auth/password-reset/' );
        },

        defaults: function () {
            return {
                email: ''
            };
        }
    });
});
